var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.164,
    height: 22.164,
    viewBox: "0 0 22.164 22.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1780",
    "data-name": "Rettangolo 1780",
    width: 22.164,
    height: 22.164
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_77",
    "data-name": "Raggruppa 77",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1398",
    "data-name": "Tracciato 1398",
    d: "M29.082,51a11.094,11.094,0,1,0,7.833,3.249A11.082,11.082,0,0,0,29.082,51Zm.462,19.371V69.184a3.87,3.87,0,0,0-3.87-3.869h-.009a2.9,2.9,0,0,1-2.053-.851l-2.82-2.821a8.3,8.3,0,0,1,12.922-6.457,1.43,1.43,0,0,1-.843.277H31.547A1.436,1.436,0,0,0,30.111,56.9v.962A1.436,1.436,0,0,1,28.675,59.3a1.436,1.436,0,0,0-1.44,1.436V61.7a1.436,1.436,0,0,0,1.436,1.436h3.838a1.436,1.436,0,0,1,1.436,1.436v1.4a1.436,1.436,0,0,0,.421,1.016l.769.769A8.278,8.278,0,0,1,29.544,70.371Z",
    transform: "translate(-18 -51)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldIcon);
export default __webpack_public_path__ + "static/media/world-icon.b6bd8927cc03a0514e0166b5ad2eb6cd.svg";
export { ForwardRef as ReactComponent };